export default __webpack_public_path__ + "static/media/sustentabilidade_content.179aa3ee.jpg";